import React, { useState, useEffect } from "react";
import Notifications from "../Admin-Dashboard-Component/Comman/Notifications";
import { FiBookOpen } from "react-icons/fi";
import studentApi from "../../Components/Dashboard-Components/StudentApi";
import './StudentNotifications.css';

const StudentNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const studentData = JSON.parse(localStorage.getItem("studentData"));
  const studentId = studentData?.id;

  // Fetch vouchers 1 day before expiry
  const fetchExpiringVouchers = async () => {
    if (!studentId) return;

    try {
      const res = await studentApi.get(`/students/${studentId}/vouchers/expiring`);
      const vouchers = res.data.data || [];

      const today = new Date();
      const expiringNotifications = vouchers
        .filter(v => v.To_Date)
        .filter(v => {
          const toDate = new Date(v.To_Date);
          const diffDays = Math.ceil((toDate - today) / (1000 * 60 * 60 * 24));
          return diffDays === 1; // 1 day before expiry
        })
        .map(v => ({
          id: v.id,
          type: "voucher",
          message: `Voucher ${v.code} for ${v.exam_name || '-'} / ${v.subject_name || '-'} / ${v.topic_name || '-'} expires tomorrow.`,
          time: "Tomorrow",
          read: false,
          icon: <FiBookOpen />,
          voucherId: v.id
        }));

      setNotifications(expiringNotifications);
    } catch (err) {
      console.error("Error fetching expiring vouchers:", err);
    }
  };

  useEffect(() => {
    fetchExpiringVouchers();
  }, [studentId]);

  const handleMarkAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  };

  const handleMarkAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  const handleResetVoucher = async (voucherId) => {
    try {
      const res = await studentApi.post(`/vouchers/${voucherId}/reset`);
      if (res.data.success) {
        alert("Voucher reset successfully!");
        // Remove notification locally
        setNotifications((prev) => prev.filter(n => n.voucherId !== voucherId));
      }
    } catch (err) {
      console.error("Error resetting voucher:", err);
      alert("Failed to reset voucher.");
    }
  };

  // Add action button for vouchers
  const notificationsWithReset = notifications.map(n => ({
    ...n,
    action: n.type === 'voucher' ? (
      <button
        onClick={() => handleResetVoucher(n.voucherId)}
        className="reset-voucher-btn"
      >
        Reset Voucher
      </button>
    ) : null
  }));

  // Debug: check what is being passed
  console.log("Notifications with reset button:", notificationsWithReset);

  return (
    <div className="student-notifications-container">
      <Notifications
        title="Student Notifications"
        notifications={notificationsWithReset}
        onMarkAllAsRead={handleMarkAllAsRead}
        onMarkAsRead={handleMarkAsRead}
      />
    </div>
  );
};

export default StudentNotifications;
